<template>
  <div class="edit">
    <div class="edit_header">
      <div class="edit_header_title">
        <slot name="edit-header-title"></slot>
      </div>
    </div>
    <div class="edit_content">
      <div class="edit_content_container">
        <slot name="edit-content-container"></slot>
      </div>
      <div class="edit_content_footer">
        <slot name="edit-content-footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
@import url("./edit.scss");
</style>